var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Icon from 'common/UIToolKit/Icon.vue';
import { Job, JobStatus } from 'packages/v3/jobs/Job';
import CampaignStatusBadge from '../campaign/CampaignStatusBadge.vue';
var JobSummary = /** @class */ (function (_super) {
    __extends(JobSummary, _super);
    function JobSummary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.iconForJobStatus = {
            open: 'open-to-candidates',
            processing: 'processing-candidates',
            completed: 'completed',
            draft: 'draft',
        };
        return _this;
    }
    Object.defineProperty(JobSummary.prototype, "JobStatus", {
        get: function () {
            return JobStatus;
        },
        enumerable: false,
        configurable: true
    });
    JobSummary.prototype.getJobStatus = function (status) {
        switch (status) {
            case 'open':
                return this.$t('jobs.statuses.open');
            case 'draft':
                return this.$t('jobs.statuses.draft');
            case 'processing':
                return this.$t('jobs.statuses.processing');
            case 'completed':
            default:
                return this.$t('jobs.statuses.completed');
        }
    };
    var _a;
    __decorate([
        Prop({ required: true }),
        __metadata("design:type", typeof (_a = typeof Job !== "undefined" && Job) === "function" ? _a : Object)
    ], JobSummary.prototype, "job", void 0);
    JobSummary = __decorate([
        Component({
            components: {
                CampaignStatusBadge: CampaignStatusBadge,
                Icon: Icon,
            },
        })
    ], JobSummary);
    return JobSummary;
}(Vue));
export default JobSummary;
